import {
  Palette, RefreshCcw, Code2, MousePointerClick, Target, BarChart3,
  Zap, Layers, Sparkles, ShoppingBag, TrendingUp, Brush
} from "lucide-react";
import Reveal from "@/components/common/Reveal";

const services = [
  { Icon: Palette, title: "Shopify Store Design", desc: "CRO-first store experiences engineered to convert browsers into loyal buyers." },
  { Icon: RefreshCcw, title: "Shopify Redesign", desc: "Transform underperforming stores into premium, conversion-optimized experiences." },
  { Icon: Code2, title: "Custom Development", desc: "Bespoke Shopify functionality, app integrations, and headless commerce." },
  { Icon: MousePointerClick, title: "CRO Optimization", desc: "Data-driven A/B testing, heatmaps, and funnel rewiring for maximum ROI." },
  { Icon: Target, title: "Meta Ads Management", desc: "Full-funnel Meta campaigns: prospecting, retargeting, creative testing at scale." },
  { Icon: BarChart3, title: "Google Ads Management", desc: "Search, Shopping, and Performance Max campaigns built for profitable scale." },
  { Icon: Layers, title: "Funnel Building", desc: "Engineered upsell, cross-sell, and post-purchase flows that compound AOV." },
  { Icon: Zap, title: "Speed Optimization", desc: "Sub-2s LCP, Core Web Vitals fixes, and mobile-first performance tuning." },
  { Icon: ShoppingBag, title: "Product Page Optimization", desc: "PDPs that sell — premium copy, social proof, sticky CTAs, fast-load media." },
  { Icon: Brush, title: "Creative Strategy", desc: "Scroll-stopping ads, UGC, and brand creative aligned with performance goals." },
  { Icon: TrendingUp, title: "Performance Marketing", desc: "Cross-channel growth strategy with weekly KPI reviews and clear ROAS targets." },
  { Icon: Sparkles, title: "End-to-End Scaling", desc: "From $50K to $5M/month — design, ads, retention, and ops working as one system." },
];

export default function Services() {
  return (
    <section data-testid="services-section" className="relative py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="orb top-1/4 -right-40 w-[500px] h-[500px] bg-blue-600/15" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <span className="inline-block text-xs uppercase tracking-[0.25em] text-blue-400 font-bold mb-4">
            What we do
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
            Full-stack eCommerce growth,<br />
            <span className="text-gradient">engineered for scale.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-zinc-400 leading-relaxed">
            Twelve specialised disciplines, one obsessive goal: profitable, predictable growth
            for ambitious D2C brands.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.04}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s/g, "-")}`}
                className="shine relative h-full overflow-hidden rounded-3xl bg-[#0A0A0C] border border-white/5 p-6 lg:p-8 transition-all duration-500 hover:border-blue-500/30 hover:bg-[#0c0c10]"
              >
                <div className="h-12 w-12 grid place-items-center rounded-2xl bg-gradient-to-br from-blue-500/20 to-indigo-500/10 border border-white/5 mb-6">
                  <s.Icon className="h-5 w-5 text-blue-300" />
                </div>
                <h3 className="font-display text-xl font-bold text-white tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
                <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
